export const PINNCALE_LOG_OBJ = {
  systemName: 'WORKFLOW',
  enteredBranchCode: '',
  customerServiceFollowUpDate: '',
  customerServiceFollowUpTime: '',
  comment: '',
  isPermanent: true,
  thirdPartySequenceNumber: null,
  contactThirdPartySequenceNumber: null,
  createdBy: '',
  createdTimeStamp: '2024-06-14 17:20:29',
  typeCode: 4,
  actionCode: 137,
  partyCode: 6,
  resultsCode: 466,
  reasonCode: 370,
  rootCause: 78,
  categoryCode: 52,
  receivableAccountNumber: 58772772,
  coBusCd: 1,
  promiseToPayDate1: null,
  promiseToPayAmount1: null,
  promiseToPayDate2: null,
  promiseToPayAmount2: null,
};
